import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import Vant from "vant/es";
import { Toast } from "vant";
import "vant/lib/index.css";
import "./assets/css/resetui.css";
import "./assets/css/quill.core.css";
import { setToken, getToken } from "@/utils/auth";
// import Vconsole from "vconsole";
// const vConsole = new Vconsole();
if (process.env.NODE_ENV === "development") {
  setToken("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsImxvZ2luSWQiOiIwMTo4OTYiLCJyblN0ciI6IjVoR0RsY2JhT3JzZnlTTXFYcGJFZmNpRXBuemxWeWV6IiwidXNlcklkIjo4OTZ9.ndgMf9lhSL6Od4eymh7hmlZvu93-e24qGc-Ea-iZEGo");
  console.log(getToken());
}

store._state.data.href = location.href.split("#")[0];
Toast.setDefaultOptions({ duration: 3000 });
createApp(App).use(store).use(router).use(Vant).mount("#app");
